import { APP_MODULE_CHANGE_ENV } from '../constants';

export const changeModuleEnv = (moduleName, env) => (dispatch) => dispatch({
    type: APP_MODULE_CHANGE_ENV,
    payload: {moduleName, env}
});